<template>
  <div class="container content">


    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <h1 class="title">New Order</h1>
        </div>
      </div>
      <div class="level-right" v-if="selectedUser !== false">
        <div class="level-item">
          <button type="button" class="button is-danger" @click="deselectCustomer()">
            Cancel Order
          </button>
        </div>
      </div>
    </div>

    <div class="order-form">
      <div class="order-form-lookup" v-if="selectedUser === false">
        <div class="level">
          <div class="level-left">
            <div class="level-item">
              <h2 class="title is-5">Quick Lookup</h2>
            </div>
            <div class="level-item">
              <button type="button" class="button" @click="show_lookup = !show_lookup">
                {{ show_lookup ? 'Hide Lookup' : 'Show Lookup'}}
              </button>
            </div>
          </div>
        </div>
        <div v-show="show_lookup">
          <input type="text"
                 class="input"
                 name="lookup"
                 placeholder="Search via Customer Number, Name (Last or First and Last), Zip, Phone, or Email"
                 v-model="lookup_terms"
                 @keyup="lookup_start">
          <p>
            <small>
              <br />
              <h4 class="title is-6 is-marginless">Lookup instructions:</h4>
              Via Customer Number (min 6 digits max 8)
              <br />
              Via Name (type the Last only, or in order of First and Last)
              <br />
              Via Zip (must be 5 digits)
              <br />
              Via Phone (must be 10 digits)
              <br />
              Via Email (valid email format (e.g. test@example.domain)
            </small>
          </p>
          <div class="lookup-results" v-if="lookup_results.length > 0">
            <div v-for="(user, index) in lookup_results" class="lookup-result">
              <button type="button" class="button is-small is-pulled-right"
                      @click="selectCustomer(user)">
                Select
              </button>
              {{ companies[user.company]['name'] }}
              -
              <strong>{{ user.account_number ? user.account_number : 'N/A' }}</strong>
              <br />
              <strong>{{ user.first_name }} {{ user.last_name }}</strong>
              <br />
              <em>
                {{ user.line1 }}
                <br v-if="user.line2" />
                {{ user.line2 }}
                <br />
                {{ user.city }}, {{ user.state }} {{ user.zip }}
              </em>
              <br />
              {{ user.phone | phone }}
              <br />
              {{ user.email }}
              <br />
              <em><strong>{{ user.recipients.length }}</strong> consignees</em>
            </div>
          </div>
        </div>
      </div>

      <hr />
      <div class="order-form-billing">
        <h2 class="title is-4">Customer/Billing Details</h2>
        <div class="columns">
          <div class="column is-6">
            <div :class="{'level lookup-result no-float':true, 'colored': billing.id !== null}" v-if="!showBillingEdit">
              <div class="level-left">
                <div class="level-item">
                  <div>
                    <strong>{{ companies[billing.company]['name'] }} {{ billing.account_number }}</strong>
                    <br/>
                    <strong>{{ billing.first_name }} {{ billing.last_name }}</strong>
                    <br />
                    <em>
                      {{ billing.line1 }}
                      <br v-if="billing.line2" />
                      {{ billing.line2 }}
                      <br />
                      {{ billing.city }}, {{ billing.state }} {{ billing.zip }}
                    </em>
                  </div>
                </div>
                <div class="level-item">
                  <div>
                    {{ billing.phone | phone }}
                    <br />
                    {{ billing.email }}
                  </div>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <button type="button" class="button" @click="toggleEdit()">Edit</button>
                </div>
              </div>
            </div>
            <div v-if="showBillingEdit">
              <div class="columns">
                <div class="column is-6">
                  <form-group type="select"
                              label="Company"
                              id="company"
                              :options="companies"
                              option_name="name"
                              option_value="initials"
                              v-model="billing.company"
                              :error="billing.errors.get('company')"
                              @event="billing.listen(billing, $event)">
                  </form-group>
                </div>
                <div class="column is-6">
                  <form-group type="text"
                              label="Customer Number"
                              id="account_number"
                              placeholder="Lookup customer in P&D"
                              v-model="billing.account_number"
                              :error="billing.errors.get('account_number')"
                              @event="billing.listen(billing, $event)">
                  </form-group>
                </div>
              </div>
              <div class="columns">
                <div class="column is-5">
                  <form-group type="text"
                              label="First Name"
                              id="bill_first_name"
                              v-model="billing.first_name"
                              :error="billing.errors.get('first_name')"
                              @event="billing.listen(billing, $event)">
                  </form-group>
                </div>
                <div class="column is-7">
                  <form-group type="text"
                              label="Last Name"
                              id="bill_last_name"
                              v-model="billing.last_name"
                              :error="billing.errors.get('last_name')"
                              @event="billing.listen(billing, $event)">
                  </form-group>
                </div>
              </div>
              <div class="columns">
                <div class="column is-8">
                  <form-group type="text"
                              label="Email"
                              id="bill_email"
                              v-model="billing.email"
                              :error="billing.errors.get('email')"
                              @event="billing.listen(billing, $event)">
                  </form-group>
                </div>
                <div class="column is-4">
                  <form-group type="text"
                              label="Phone"
                              id="bill_phone"
                              ref="bill_phone"
                              mask="### ### ####"
                              :save-mask="false"
                              v-model="billing.phone"
                              :error="billing.errors.get('phone')"
                              @event="billing.listen(billing, $event)">
                  </form-group>
                </div>
              </div>
              <form-group type="text"
                          ref="autocomplete"
                          label="Street Address"
                          placeholder="Street and number, P.O. box, c/o"
                          id="bill_line1"
                          v-model="billing.line1"
                          :error="billing.errors.get('line1')"
                          @event="billing.listen(billing, $event)">
              </form-group>
              <form-group type="text"
                          placeholder="Apartment, suite, unit, building, floor, etc."
                          id="bill_line2"
                          v-model="billing.line2"
                          :error="billing.errors.get('line2')"
                          @event="billing.listen(billing, $event)">
              </form-group>
              <div class="columns">
                <div class="column is-6">
                  <form-group type="text"
                              label="City"
                              id="bill_city"
                              v-model="billing.city"
                              :error="billing.errors.get('city')"
                              @event="billing.listen(billing, $event)">
                  </form-group>
                </div>
                <div class="column is-3">
                  <form-group type="states"
                              label="State"
                              id="bill_state"
                              v-model="billing.state"
                              :error="billing.errors.get('state')"
                              @event="billing.listen(billing, $event)">
                  </form-group>
                </div>
                <div class="column is-3">
                  <form-group type="text"
                              label="Zip"
                              id="bill_zip"
                              v-model="billing.zip"
                              :error="billing.errors.get('zip')"
                              @event="billing.listen(billing, $event)">
                  </form-group>
                </div>
              </div>

              <div v-if="verify_error || address_verify">
                <strong>USPS Address Verify Result:</strong>
                <div v-if="address_verify !== null">
                  {{ address_verify.line1 }}
                  <br v-if="address_verify.line2" />
                  {{ address_verify.line2 }}
                  <br />
                  {{ address_verify.city }}, {{ address_verify.state }} {{ address_verify.zip }}
                  <br />
                  <strong>{{ address_verify.details }}</strong>
                  <br />
                  <button type="button"
                          :class="{'button': true, 'is-success': addressMatch, 'is-warning': !addressMatch}"
                          @click="confirmMatch()">
                    {{ addressMatch ? 'Confirm Match' : 'Update' }}
                  </button>
                </div>

                <div v-if="verify_error">
                  {{ verify_error.Description }}
                  <br />
                  <button type="button" class="button" @click="acknowledgeError()">Okay.</button>
                </div>
              </div>

              <div class="level">
                <div class="level-left">
                  <div class="level-item">
                  </div>
                </div>
                <div class="level-right" v-if="showBillingEdit">
                  <div class="level-item">
                    <button type="button"
                            class="button"
                            @click="address_lookup()">
                      Verify Address
                    </button>
                  </div>
                  <div class="level-item">
                    <button type="button"
                            class="button is-primary"
                            @click="toggleEdit()">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-5">
            <form-group type="text"
                        label="Credit Card Number"
                        id="cc_number"
                        v-model="billing.cc_number"
                        :error="billing.errors.get('cc_number')"
                        @event="billing.listen(billing, $event)">
            </form-group>
            <div class="columns">
              <div class="column is-6">
                <form-group type="text"
                            label="Credit Card Expire"
                            id="cc_expire"
                            mask="##/##"
                            v-model="billing.cc_expire"
                            :error="billing.errors.get('cc_expire')"
                            @event="billing.listen(billing, $event)">
                </form-group>
              </div>
              <div class="column is-6">
                <form-group type="text"
                            label="Credit Card Security Code"
                            id="cc_sec"
                            mask="####"
                            v-model="billing.cc_sec"
                            :error="billing.errors.get('cc_sec')"
                            @event="billing.listen(billing, $event)">
                </form-group>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="mega-hr" />

      <h2 class="title is-4">Consignees/Order</h2>

      <div class="order-form-recipients">
        <recipient-form-part v-for="(recipient, index) in recipients"
                             :key="recipient.uuid"
                             :details="recipient"
                             :index="index"
                             @remove="removeRecipient"
        ></recipient-form-part>

        <button type="button" class="button is-primary" @click="addRecipient">New Consignee</button>
        <button type="button" class="button" @click="showRecipients = !showRecipients"
                v-if="availableRecipients.length > 0">
          {{ showRecipients ? 'Hide User Consignees' : 'Show User Consignees'}}
        </button>
      </div>
      <div v-show="showRecipients">
        <div class="available-recipients lookup-results">
          <div v-for="(recipient, index) in remainingRecipients" :key="recipient.id" class="lookup-result">
            <button type="button" class="button is-small is-pulled-right"
                    @click="addRecipient(recipient)">Select
            </button>
            <strong>{{ recipient.first_name }} {{ recipient.last_name }}</strong>
            <br />
            <em>
              {{ recipient.line1 }}
              <br v-if="recipient.line2" />
              {{ recipient.line2 }}
              <br />
              {{ recipient.city }}, {{ recipient.state }} {{ recipient.zip }}
            </em>
            <br />
            {{ recipient.phone | phone }}
            <br />
            {{ recipient.email }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api           from "../../store/api"
import {mapGetters}       from "vuex"
import Form               from "../../helpers/Form"
import {SUBMIT_NEW_ORDER} from "../../store/mutation-types"
import * as seasonTools   from "../../utils/season"

export default {
  name: 'create-order',
  data() {
    return {
      show_lookup: true,
      showBillingEdit: true,
      lookup_terms: null,
      lookup_timeout: 0,
      lookup_delay: 1000,
      lookup_results: [],
      selectedUser: false,
      showRecipients: true,
      autocomplete: null,
      address_verify: null,
      verify_error: null,
      billing: new Form(this, {
        company: 'CF',
        id: null,
        account_number: '',
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        line1: null,
        line2: null,
        city: null,
        state: null,
        zip: null,
        cc_number: null,
        cc_expire: null,
        cc_sec: null,
      }, SUBMIT_NEW_ORDER),
      recipients: [],
      availableRecipients: [],
    }
  },
  computed: {
    ...mapGetters([
      'companies',
      'products',
      'months',
      'users',
      'userRecipients',
      'newOrders',
      'discounts',
    ]),
    addressMatch() {
      if (this.address_verify !== null) {
        let localAddress = {
          line1: this.billing.line1.toLowerCase(),
          line2: (this.billing.line2) ? this.billing.line2.toLowerCase() : '',
          city: this.billing.city.toLowerCase(),
          state: this.billing.state.toLowerCase(),
          zip: this.billing.zip.toLowerCase(),
        };
        let uspsAddress  = {
          line1: this.address_verify.line1.toLowerCase(),
          line2: (this.address_verify.line2) ? this.address_verify.line2.toLowerCase() : '',
          city: this.address_verify.city.toLowerCase(),
          state: this.address_verify.state.toLowerCase(),
          zip: this.address_verify.zip.toLowerCase(),
        };
        let match        = true;
        if (localAddress.line1 !== uspsAddress.line1) match = false;
        if (localAddress.line2 !== uspsAddress.line2) match = false;
        if (localAddress.city !== uspsAddress.city) match = false;
        if (localAddress.state !== uspsAddress.state) match = false;
        if (localAddress.zip !== uspsAddress.zip) match = false;

        return match;
      }

      return true;
    },
    remainingRecipients() {
      let selectedRecipientIds = this.recipients.map(r => r.id)

      return this.availableRecipients.filter(r => {
        return selectedRecipientIds.indexOf(r.id) === -1
      })
    }
  },
  mounted() {
    this.setupAutocomplete();
  },
  methods: {
    confirmMatch() {
      this.billing.line1  = this.address_verify.line1;
      this.billing.line2  = this.address_verify.line2;
      this.billing.city   = this.address_verify.city;
      this.billing.state  = this.address_verify.state;
      this.billing.zip    = this.address_verify.zip;
      this.address_verify = null;
      this.updateBilling();
    },
    acknowledgeError() {
      this.address_verify = null;
      this.verify_error   = null;
    },
    toggleEdit() {
      this.showBillingEdit = !this.showBillingEdit;
      if (!this.showBillingEdit) {
        this.autocomplete = null
      }
      else {
        setTimeout(() => {
          this.setupAutocomplete();
        }, 25)
      }

      this.updateBilling();
    },
    lookup_start() {
      clearTimeout(this.lookup_timeout);
      if (this.lookup_terms.length < 1) {
        this.lookup_results = [];
        return;
      }
      this.lookup_timeout = setTimeout(() => {
        api.request(this.$store.commit, '/users/lookup', { terms: this.lookup_terms }, 'get', false, false)
           .then(data => {
             this.lookup_results = data;
           })
      }, this.lookup_delay)
    },
    address_lookup() {
      api.request(this.$store.commit, '/address/verify', {
        line1: this.billing.line1,
        line2: this.billing.line2,
        city: this.billing.city,
        state: this.billing.state,
        zip: this.billing.zip,
      }, 'get', false, false)
         .then(data => {
           this.address_verify = data;
         })
         .catch(error => {
           if(error['error']['Error']) {
            this.verify_error = error['error']['Error'];
           }
         })
    },
    setupAutocomplete() {
      this.autocomplete = new google.maps.places.Autocomplete((this.$refs.autocomplete.$refs.form_control.$refs.input),
        { types: ['geocode'] }
      );

      this.autocomplete.setFields(['address_component']);

      this.autocomplete.addListener('place_changed', (e) => {
        let place         = this.autocomplete.getPlace();
        let ac            = place.address_components;
        let street_number = null;
        let street_name   = null;
        let line1         = null;
        let line2         = null;
        let city          = null;
        let state         = null;
        let zip           = null;
        let zip4          = null;
        for (let x = 0; x < ac.length; x++) {
          let c = ac[x];
          if (c.types.indexOf('street_number') !== -1) {
            street_number = c.short_name;
          }
          if (c.types.indexOf('route') !== -1) {
            street_name = c.short_name;
          }
          if (c.types.indexOf('locality') !== -1) {
            city = c.short_name;
          }
          if (c.types.indexOf('administrative_area_level_1') !== -1) {
            state = c.short_name;
          }
          if (c.types.indexOf('postal_code') !== -1) {
            zip = c.short_name;
          }
          if (c.types.indexOf('postal_code_suffix') !== -1) {
            zip4 = c.short_name;
          }
        }

        line1 = street_number + ' ' + street_name;
        if (zip4 !== null) {
          zip = zip + '-' + zip4;
        }

        this.billing.line1 = line1;
        this.billing.city  = city;
        this.billing.state = state;
        this.billing.zip   = zip;
        setTimeout(() => {
          window.document.getElementById('bill_line1').value = line1;
          window.document.getElementById('bill_city').value  = city;
          window.document.getElementById('bill_state').value = state;
          window.document.getElementById('bill_zip').value   = zip;
          setTimeout(() => {
            this.$forceUpdate();
          }, 25)
        }, 25)
      });
    },
    createRecipientIdentifier() {
      let uuid = Math.round(Math.random() * 1000);
      for (let x = 0; x < this.recipients.length; x++) {
        if (this.recipients[x].uuid === uuid) {
          return this.createRecipientIdentifier()
        }
      }
      return uuid;
    },
    addRecipient(recip) {
      let uuid = this.createRecipientIdentifier();

      this.recipients.push({
        uuid: uuid,
        id: recip.id ? recip.id : null,
        first_name: recip.first_name ? recip.first_name : null,
        last_name: recip.last_name ? recip.last_name : null,
        email: recip.email ? recip.email : null,
        phone: recip.phone ? recip.phone : null,
        line1: recip.line1 ? recip.line1 : null,
        line2: recip.line2 ? recip.line2 : null,
        city: recip.city ? recip.city : null,
        state: recip.state ? recip.state : null,
        zip: recip.zip ? recip.zip : null,
      });

      this.$forceUpdate();
    },
    removeRecipient(uuid) {
      this.recipients.splice(this.recipients.indexOf(this.recipients.find(r => r.uuid === uuid)), 1);
      setTimeout(() => {
        this.$forceUpdate();
      }, 50)
    },
    selectCustomer(user) {
      this.lookup_terms   = '';
      this.lookup_results = [];

      this.selectedUser = user;

      this.billing.company        = user.company;
      this.billing.account_number = user.account_number;
      this.billing.id             = user.id;
      this.billing.first_name     = user.first_name;
      this.billing.last_name      = user.last_name;
      this.billing.email          = user.email;
      this.billing.phone          = user.phone;
      this.billing.line1          = user.line1;
      this.billing.line2          = user.line2;
      this.billing.city           = user.city;
      this.billing.state          = user.state;
      this.billing.zip            = user.zip;

      this.availableRecipients = user.recipients;

      this.recipients     = [];
      this.showRecipients = true;

      this.updateBilling().then(() => {
        setTimeout(() => {
          if (this.showBillingEdit) this.toggleEdit();
        }, 25);
      });
    },
    deselectCustomer() {
      this.selectedUser = false;

      this.billing.company        = 'CF';
      this.billing.account_number = null;
      this.billing.id             = null;
      this.billing.first_name     = null;
      this.billing.last_name      = null;
      this.billing.email          = null;
      this.billing.phone          = null;
      this.billing.line1          = null;
      this.billing.line2          = null;
      this.billing.city           = null;
      this.billing.state          = null;
      this.billing.zip            = null;

      this.availableRecipients = [];
      this.recipients          = [];
      this.showRecipients      = true;
      this.show_lookup         = true;
      if (!this.showBillingEdit) {
        this.toggleEdit();
      }

      this.updateBilling()
    },
    updateBilling() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if(window.document.getElementById('company')) {
            window.document.getElementById('company').value         = this.billing.company;
            window.document.getElementById('account_number').value  = this.billing.account_number;
            window.document.getElementById('bill_first_name').value = this.billing.first_name;
            window.document.getElementById('bill_last_name').value  = this.billing.last_name;
            window.document.getElementById('bill_email').value      = this.billing.email;
            window.document.getElementById('bill_phone').value      = this.billing.phone;
            window.document.getElementById('bill_line1').value      = this.billing.line1;
            window.document.getElementById('bill_line2').value      = this.billing.line2;
            window.document.getElementById('bill_city').value       = this.billing.city;
            window.document.getElementById('bill_state').value      = this.billing.state;
            window.document.getElementById('bill_zip').value        = this.billing.zip;
            //if (this.billing.phone !== null && this.billing.phone !== '') {
              this.$refs.bill_phone.$refs.form_control.applyMask(this.billing.phone);
            //}
          }

          setTimeout(() => {
            this.$forceUpdate();
            resolve();
          }, 25)
        }, 25)
      })
    }
  }
};
</script>

<style lang="scss">
  .lookup-results {
    padding: 1rem 0;
    padding-left: 1rem;

    &:after {
      display: table;
      content: ' ';
      clear: both;
    }
  }

  .lookup-result {
    float: left;
    width: 30%;
    min-height: 210px;
    margin-right: 2%;
    margin-bottom: 1rem;
    padding: 0.5rem;
    background-color: #fafafa;
    border-radius: 1rem;

    &.no-float {
      float: none;
      width: auto;
      min-height: auto;
      margin-right: auto;
      margin-bottom: auto;
    }

    &.colored {
      background-color: #fff9d5;
    }
  }

  .mega-hr {
    height: 15px;
    background-color: #dadada;
  }
</style>



// WEBPACK FOOTER //
// CreateOrder.vue?6061c9fc